import { render } from "./Poll.vue?vue&type=template&id=05ca8c4e"
import script from "./Poll.vue?vue&type=script&lang=js"
export * from "./Poll.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__